import styled from '@emotion/styled';
import { Typography } from '@mui/material';

import { Button as ButtonBase } from '@vizsla/components';

/// Content

export const Content = styled.div`
  margin-top: 2rem;
`;

/// Buttons

export const Buttons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
`;

/// Button

export const Button = styled(ButtonBase)`
  margin: 0;
`;

Button.defaultProps = {
  variant: 'contained',
};

export const OrganizationSubtitle = styled(Typography)`
  position: relative;
  bottom: 40px;
  text-align: center;
`;

export const FirstSection = styled.div`
  display: flex;
  gap: 8px;
`;

export const SecondSection = styled.div`
  display: flex;
  gap: 8px;
`;
